import { BaseModel } from '../../../base/base-model';

export class UserModel extends BaseModel {
}
